import { CALL_API } from '../middleware/api'

export const DUPLICATED_SALES_REQUEST = 'DUPLICATED_SALES_REQUEST'
export const DUPLICATED_SALES_SUCCESS = 'DUPLICATED_SALES_SUCCESS'
export const DUPLICATED_SALES_FAILURE = 'DUPLICATED_SALES_FAILURE'

// Igual que fetchSales: se pasa "" (no undefined) para incluir un parámetro vacío. El
// middleware [CALL_API] resuelve contra API_ROOT -> duplicated-sales?...
export function fetchDuplicatedSales(Machine, Customer, StartDate, EndDate, DateField, SameAsOriginal) {
  let params = ''

  if (Machine !== undefined) {
    params += `&Machine=${Machine}`
  }

  if (Customer !== undefined) {
    params += `&Customer=${Customer}`
  }

  if (StartDate !== undefined) {
    params += `&StartDate=${StartDate}`
  }

  if (EndDate !== undefined) {
    params += `&EndDate=${EndDate}`
  }

  if (DateField !== undefined) {
    params += `&DateField=${DateField}`
  }

  if (SameAsOriginal !== undefined && SameAsOriginal !== '') {
    params += `&SameAsOriginal=${SameAsOriginal}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `duplicated-sales?${params}`,
      authenticated: true,
      types: [DUPLICATED_SALES_REQUEST, DUPLICATED_SALES_SUCCESS, DUPLICATED_SALES_FAILURE]
    }
  }
}
